var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClearField(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99004 0C12.4135 0 16 3.58655 16 7.99004C16 12.4135 12.4135 16 7.99004 16C3.58655 16 0 12.4135 0 7.99004C0 3.58655 3.58655 0 7.99004 0ZM5.61893 4.78207L7.99004 7.15318L10.3811 4.78207C10.939 4.22416 11.7559 5.06102 11.2179 5.61893L8.8269 7.99004L11.2179 10.3811C11.7559 10.939 10.939 11.7559 10.3811 11.2179L7.99004 8.8269L5.61893 11.2179C5.06102 11.7559 4.22416 10.939 4.78207 10.3811L7.15318 7.99004L4.78207 5.61893C4.22416 5.06102 5.06102 4.22416 5.61893 4.78207Z",
    fill: "#BCBEC0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearField);
export default __webpack_public_path__ + "static/media/clear-field.ac96cb4fc358ce28378262f115fb5193.svg";
export { ForwardRef as ReactComponent };